/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import { QueryProvider } from '@thd-nucleus/data-sources';
import { useStore } from '@thd-nucleus/experience-context';

import { Pep } from './Pep';

export const PepDesktopContainer = (props) => {
  const store = useStore();
  const { storeId, storeZip } = store || {};
  const defaultVariables = {
    storeId,
    zipCode: storeZip
  };

  return (
    <QueryProvider
      {...props}
      cacheKey="pep-page"
      defaultVariables={defaultVariables}
    >
      <Pep />
    </QueryProvider>
  );
};

PepDesktopContainer.displayName = 'PepDesktopContainer';
